export default "__VITE_ASSET__he0X5_d7__"